<div class="inventory-table-container">
	<div class="top-bar">
		<div class="search-bar">
			<app-search-control [control]="searchControl" placeholder="Search"></app-search-control>
			<button type="button" class="btn btn-sm btn-primary" (click)="onAddNewClick()">
				<i class="bi bi-plus"> </i>
				Add
			</button>
		</div>
		<div class="control-bar">
			<app-switch-control [formGroup]="form" name="showArchived" label="Show Archived" />
		</div>
	</div>

	<div class="content">
		<div class="section table-container">
			<div class="table-headings">
				<div class="column-name long">SKU</div>
				<div class="column-name long">Name</div>
				<div class="column-name short">Quantity</div>
				<div class="column-name action"></div>
			</div>

			<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"></app-loading-state>
			<ng-template #loadedContent>
				<ng-container *ngIf="inventoryItems.length === 0; else invItemTable">
					<div class="table-row">
						<div class="inner-row">
							<em class="fw-bold"> No inventory items. </em>
						</div>
					</div>
				</ng-container>
				<ng-template #invItemTable>
					<ng-container *ngFor="let item of inventoryItems">
						<div class="table-row">
							<div class="inner-row long">{{ item.sku | nullDefault: 'N/A' }}</div>
							<div class="inner-row long">
								{{ item.name | nullDefault: '-' }}
							</div>
							<div class="inner-row short">
								{{ item.totalQuantity | number: '1.0-2' | nullDefault: '-' }}
							</div>
							<div class="inner-row action">
								<div class="dropdown">
									<button class="btn btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false">
										<i class="bi bi-three-dots"></i>
									</button>
									<ul class="dropdown-menu">
										<li>
											<button role="button" class="dropdown-item" (click)="onInventoryItemEdit(item)">Edit</button>
										</li>
										<li>
											<button role="button" class="dropdown-item" (click)="onInventoryItemManage(item)">
												Manage Stock
											</button>
										</li>
										<li *ngIf="item.archived === false">
											<button role="button" class="dropdown-item" (click)="onInventoryItemArchive(item)">
												<div class="text-danger">Archive</div>
											</button>
										</li>
										<li *ngIf="item.archived === true">
											<button role="button" class="dropdown-item" (click)="onInventoryItemUnarchive(item)">
												<div class="text-danger">Unarchive</div>
											</button>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</ng-container>
				</ng-template>
			</ng-template>
		</div>
	</div>
</div>
